import { Modal, Spinner } from "react-bootstrap";
import TextareaAutosize from "react-textarea-autosize";
import SuggestionIcon from "../../assets/black/suggestion.png";
import Hexapi from "../../utility/HexAPI/Hexapi";
import Swal from "sweetalert2";
import { showConfirm } from "../../utility/showconfirm";
import Loader from "../loader/Loader";

const Suggestionbugmodal = ({
  isOpen,
  onClose,
  isBugSend,
  suggestionValue,
  onSuggestionChange,
 userid,
 setisBugSend,
 buildNumber
}) => {
console.log(buildNumber,"buildNumber")
   const submitBug=(e)=> {
            e.preventDefault();
            if(!userid) return
            if (suggestionValue != "") {
                setisBugSend(false)
                const obj = {
                    query: `HRApp_Droid_Proc_User_Suggestion_SubmitV2 @UserID='{0}',@Remarks='{1}',@Version='{2}'`,
                    queryArr: [
                        `${userid}`,
                        `${suggestionValue}`,
                        `${buildNumber?.buildNumber}`,
                    ],
                };
    console.log(obj,"obj")
                Hexapi(obj)
                    .then((resp) => {
                        
                        if (resp) {
                            if (resp[""][0].command == 1) {
                                
                                showConfirm({
                                  content:resp[""][0].msg,
                                  hideCancel:true
                                })
                                onClose()
                                onSuggestionChange("")
                                setisBugSend(true)
                                
                            } else if (resp[""][0].command == 0) {
                                Swal.fire({
                                    confirmButtonText: "OK",
                                    html: resp[""][0].msg,
                                });
                                onClose()
                                onSuggestionChange("")
                                setisBugSend(true)
                            }
                        } else {
                            onClose()
                                onSuggestionChange("")
                                setisBugSend(true)
                        }
                    });
            } else {
                
                showConfirm({
                  content:"Issue is Required",
                  hideCancel:true
                })
            }

        }
  return (
    <Modal
      size="sm"
      centered
      id="bugs"
      style={{ backdropFilter:"blur(6px)" }}
      animation={true}
      show={isOpen}
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <div className="Header">
          <div className="image">
            <img
              src={SuggestionIcon}
              alt="Suggestion Icon"
              style={{
                filter:
                  "invert(28%) sepia(94%) saturate(1224%) hue-rotate(-13deg) brightness(104%) contrast(95%)",
              }}
            />
          </div>
          <span>Suggestion / Bug Report</span>
        </div>
      </Modal.Header>

      <Modal.Body>
        {isBugSend ? (
          <div className="form">
            <TextareaAutosize
              className="form-control"
              placeholder="Specify issue"
              cacheMeasurements
              minRows={1}
              maxRows={6}
              value={suggestionValue}
              onChange={(e) => onSuggestionChange(e.target.value)}
            />
            <span onClick={submitBug}>Submit</span>
          </div>
        ) : (
          <div
            style={{
              width: "100%",
              height: "14vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loader />
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
export default Suggestionbugmodal;